/**
 * How a GLOBAL shortcut defers to the sidebar's multi-selection.
 *
 * The duplicate shortcut (Ctrl/Cmd+D) is handled on `document` in the capture
 * phase (hooks/useKeyboardShortcuts), which runs before anything inside the
 * sidebar can see the key — so the sidebar cannot intercept it the way it does
 * Delete. And that handler knows only the ONE selected row: with eight rows
 * marked it duplicated one of them (owner, 18.09.2026: "multi selected are not
 * working with duplicate").
 *
 * The marked set lives in the sidebar, not in a store, on purpose (it is view
 * state, cleared on workspace switch). So instead of lifting it, the sidebar
 * registers one function here and the global handler asks it first.
 */

let bulkDuplicate = null;

/** Register the sidebar's handler. Returns the unregister function. */
export function registerBulkDuplicate(fn) {
  bulkDuplicate = fn;
  return () => {
    if (bulkDuplicate === fn) bulkDuplicate = null;
  };
}

/**
 * True when the sidebar had a multi-selection and took the shortcut — the
 * caller must then do nothing else.
 */
export function runBulkDuplicate() {
  return bulkDuplicate ? bulkDuplicate() === true : false;
}
